module.exports = __webpack_public_path__ + "public/img/tiku_cbg1select.668e8fb8.png";